<template>
    <div>
        <!--<div class="row mb-3">-->
        <!--<div class="col-12">-->
        <!--<h1 class="h2 mb-0">Data for November 2018</h1>-->
        <!--</div>-->
        <!--</div>-->


        <!--<div class="row mb-3">-->
        <!--<div class="col-lg-4">-->
        <!--<div class="input-group shadow">-->
        <!--<input class="form-control bg-white"-->
        <!--type="text"-->
        <!--name="daterange"-->
        <!--:placeholder="$t('message.dateFilter')"-->
        <!--@focus="openDateRange">-->
        <!--<div class="input-group-append bg-white">-->
        <!--<button class="btn btn-danger"-->
        <!--type="button"-->
        <!--v-if="dateFilter"-->
        <!--@click="appendData(); dateFilter = !dateFilter">-->
        <!--{{$t('message.clean')}}-->
        <!--</button>-->
        <!--<div v-else-->
        <!--class="input-group-text bg-white px-1 d-flex justify-content-center align-items-center">-->
        <!--<span class="icon-calendar"></span>-->

        <!--</div>-->
        <!--</div>-->
        <!--</div>-->

        <!--</div>-->
        <!--</div>-->
        <div class="row">
            <!--<div class="col-lg-4 mb-3">-->
            <!--<div class="bg-white rounded pb-3 shadow">-->
            <!--<nav class="mb-2">-->
            <!--<div class="nav nav-tabs bg-color-4 rounded-top" id="nav-tab" role="tablist">-->
            <!--<a v-for="(lead, i) in leads"-->
            <!--class="nav-item nav-link px-1 py-1 h6"-->
            <!--:class="{'active': i === 0}"-->
            <!--:id="`nav-${i}-tab`"-->
            <!--data-toggle="tab"-->
            <!--:href="`#nav-${i}`"-->
            <!--role="tab"-->
            <!--:aria-controls="`nav-${i}`"-->
            <!--aria-selected="true">-->
            <!--{{lead.leadType}}-->
            <!--</a>-->
            <!--</div>-->
            <!--</nav>-->
            <!--<router-link to="leads" class="d-flex justify-content-between align-items-center px-3">-->
            <!--<div class="tab-content" id="nav-tabContent">-->
            <!--<div v-for="(lead, i) in leads"-->
            <!--class="tab-pane fade"-->
            <!--:class="{'show active': i === 0}"-->
            <!--:id="`nav-${i}`"-->
            <!--role="tabpanel"-->
            <!--:aria-labelledby="`nav-${i}-tab`">-->
            <!--<span class="h1 text-color-1 d-block mb-0">{{lead.count ? lead.count : 0}}</span>-->
            <!--</div>-->
            <!--<span class="h3 text-color-7 d-block mb-0">{{$t('dashboard.leads')}}</span>-->
            <!--</div>-->
            <!--<div class="text-center">-->
            <!--<img src="@/assets/approved.png" alt="">-->
            <!--</div>-->
            <!--</router-link>-->
            <!--</div>-->
            <!--</div>-->

            <div class="col-lg-4 mb-3">
                <div class="bg-white rounded shadow d-flex flex-column justify-content-between h-100">
                    <router-link to="leads" class="d-flex justify-content-between p-3">
                        <div>
                            <span class="h1 text-color-1 d-block mb-0">{{totals.leads ? totals.leads : 0}}</span>
                            <span class="h3 text-color-7 d-block mb-0">{{$t('dashboard.leads')}}</span>
                        </div>
                        <div class="text-center">
                            <img src="@/assets/approved.png" alt="">
                        </div>
                    </router-link>

                    <ul class="p-0 m-1 d-flex flex-wrap">
                        <li v-for="(lead, i) in leads"
                            class="d-flex flex-column text-center p-1 align-self-baseline"
                            :style="`width: ${100 / leads.length}%`"
                            :class="i != 0 ? 'border-right-1 border-color-5' : ''">
                            <router-link :to="`leads?tcfilter=leadType,${lead.key}`" class="d-flex flex-column text-center p-1">
                                <span class="h2 mb-0">{{lead.count}}</span>
                                <span>{{lead.key}}</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-8">
                <div class="row">
                    <div class="col-lg-6 mb-3">
                        <router-link
                                to="orders"
                                class="bg-white rounded p-3 shadow d-flex justify-content-between align-items-center h-100">
                            <div>
                                <span class="h1 text-color-1 d-block mb-0">{{totals.orders ? totals.orders : 0}}</span>
                                <span class="h3 text-color-7 d-block mb-0">{{$t('dashboard.orders')}}</span>
                            </div>
                            <div class="text-center">
                                <img src="@/assets/icon2.png"
                                     alt="">
                            </div>
                        </router-link>
                    </div>

                    <div class="col-lg-6 mb-3">
                        <router-link
                                to="tasks"
                                class="bg-white rounded p-3 shadow d-flex justify-content-between align-items-center h-100">
                            <div>
                                <span class="h1 text-color-1 d-block mb-0">{{totals.tasks ? totals.tasks : 0}}</span>
                                <span class="h3 text-color-7 d-block mb-0">{{$t('dashboard.tasks')}}</span>
                            </div>
                            <div class="text-center">
                                <img src="@/assets/pending.png"
                                     alt="">
                            </div>
                        </router-link>
                    </div>

                    <div class="col-lg-6 mb-3">
                        <router-link
                                to="renewals"
                                class="bg-white rounded p-3 shadow d-flex justify-content-between align-items-center h-100">
                            <div>
                                <span class="h1 text-color-1 d-block mb-0">{{totals.renewals ? totals.renewals : 0}}</span>
                                <span class="h3 text-color-7 d-block mb-0">{{$t('dashboard.renewals')}}</span>
                            </div>
                            <div class="text-center">
                                <img src="@/assets/icon1.png"
                                     alt="">
                            </div>
                        </router-link>
                    </div>

                    <div class="col-lg-6 mb-3" v-if="isAdmin">
                        <router-link
                                to="clients"
                                class="bg-white rounded p-3 shadow d-flex justify-content-between align-items-center h-100">
                            <div>
                                <span class="h1 text-color-1 d-block mb-0">{{totals.customers ? totals.customers : 0}}</span>
                                <span class="h3 text-color-7 d-block mb-0">{{$t('dashboard.newCustomers')}}</span>
                            </div>
                            <div class="text-center">
                                <img src="@/assets/started.png"
                                     alt="">
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>


        </div>


        <div v-if="isAdmin" class="row mb-3">

            <div :class="[isAdmin ? 'col-lg-4' : 'col-lg-6']">
                <div class="bg-white rounded p-3 shadow d-flex flex-column justify-content-between">
                    <h2>
                        {{$t('dashboard.productsCurrentMonth')}}</h2>
                    <bar-chart
                            v-if="productsData"
                            :labels="productsLabels"
                            :data="productsData"
                            :tooltips="productsTooltips"
                            class="w-100"></bar-chart>
                    <div class="d-flex justify-content-around align-items-center">
                        <div>
                            <span>{{$t('dashboard.totalProducts')}}: </span><span>{{productsTotals}}</span>
                        </div>
                        <div v-if="isAdmin">
                            <span>{{$t('dashboard.totalIncome')}}: </span><span>₪{{productsRevenue}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="[isAdmin ? 'col-lg-4' : 'col-lg-6']" v-if="isAdmin">
                <div class="bg-white rounded p-3 shadow d-flex flex-column justify-content-between">
                    <h2>{{$t('dashboard.revenueCurrentMonth')}}</h2>
                    <bar-chart
                            v-if="adminSalesData"
                            :labels="adminSalesLabels"
                            :data="adminSalesData"
                            :tooltips="adminSalesData"
                            class="w-100"></bar-chart>
                </div>
            </div>

            <div :class="[isAdmin ? 'col-lg-4' : 'col-lg-6']">
                <div class="bg-white rounded p-3 shadow d-flex flex-column justify-content-between">
                    <h2>{{$t('dashboard.ordersLast2Monthes')}}</h2>
                    <line-chart
                            v-if="ordersData"
                            :labels="ordersLabels"
                            :data="ordersData"
                            class="w-100"></line-chart>
                </div>
            </div>

        </div>


        <!--<template v-if="isAdmin && dataTableReady">-->
        <!--<datatable-->
        <!--:tcols="cols"-->
        <!--:trows="rows"-->
        <!--:tconfig="config"-->
        <!--:readonly="true"-->
        <!--:title="$t('message.renewals')"/>-->
        <!--</template>-->

    </div>
</template>

<script>
  import axios
    from '../axios'
  import datatable
    from '@/components/datatable'

  // data charts: https://www.sitepoint.com/creating-beautiful-charts-vue-chart-js/
  import barChart
    from '@/components/charts/barChart'
  import lineChart
    from '@/components/charts/lineChart'

  export default {
    components: {
      barChart,
      lineChart,
      datatable
    },

    async mounted () {
      this.appendData()
    },
    data () {
      return {
        dateFilter: false,

        totals: {
          leads: '',
          orders: '',
          tasks: '',
          renewals: '',
          customers: '',
        },
        leads: '',

        adminSalesLabels: [],
        adminSalesData: [],

        productsLabels: [],
        productsData: [],
        productsTooltips: [],
        productsTotals: '',
        productsRevenue: '',

        ordersLabels: [],
        ordersData: [],

        // dataTableReady: false,
        // cols: [],
        // rows: [],
        // config: ''
      }
    },
    created() {
      // if the agent return from order->single we show again the aside bar
      if($('.aside-table' ).hasClass( "d-none" )){
         $('.aside-table').removeClass('d-none')
      }
    },
    computed: {
      isAdmin () {
        return this.$store.getters.isAdmin
      }
    },
    methods: {
      calcTotal (arr) {
        let total = 0
        arr.map((num) => {
          total += parseInt(num)
        })
        return total
      },

      appendData () {
        axios.get('/dashboard/all')
          .then((res) => {
            let data = res.data.data

            this.totals.leads = data.total.leads
            this.totals.orders = data.total.orders
            this.totals.renewals = data.total.renewals
            this.totals.tasks = data.total.tasks
            this.leads = data.leads
            if (this.isAdmin) {
              this.totals.customers = data.adminData.newCustomers
              this.adminSalesLabels = data.adminData.sales.labels
              this.adminSalesData = data.adminData.sales.data
            }

            this.productsLabels = data.products.labels
            this.productsData = data.products.data
            this.productsTotals = this.calcTotal(data.products.data)
            this.productsRevenue = this.calcTotal(data.products.toolTips)
            this.productsTooltips = data.products.toolTips

            this.ordersLabels = data.orders.currentMonth.labels
            let ordersData = []
            for (let i in data.orders) {
              ordersData[i] = data.orders[i].data
            }
            this.ordersData = ordersData

            // const resData = data.renewals
            // if (resData.length > 0) {
            //
            //   let resKeys = Object.keys(resData[0])
            //
            //   resKeys = _.without(resKeys, 'created_at', 'updated_at')
            //
            //   this.cols = resKeys
            //   this.rows = resData
            // }
            //
            // this.dataTableReady = true

          })
          .catch((err) => {
            console.log(err)
            // this.$emit('alert', 'danger', err.response.data.status)
          })

      },
      openDateRange () {
        let that = this
        //http://www.daterangepicker.com/#options
        $('input[name="daterange"]').daterangepicker({
          'alwaysShowCalendars': true,
          opens: 'center',
          ranges: {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
          },
          locale: {
            format: 'DD/MM/YY',
            'firstDay': 0
          }
        }).on('apply.daterangepicker', function (ev, picker) {
          that.getRecordsByDate(picker.startDate.format('YYYY-MM-DD'), picker.endDate.format('YYYY-MM-DD'))
        })
      },

      getRecordsByDate (startDate, endDate) {

        let data = {
          startDate: startDate,
          endDate: endDate
        }

        axios.post(`/dashboard/dateFilter`, data)
          .then((res) => {
            if (res.data.data.error) {
              this.$emit('alert', 'danger', res.data.data.error)
              return
            }
            this.dateFilter = true

            let data = res.data.data
            this.leads = data.leads
            this.orders = data.orders
            this.tasks = data.tasks

            this.barChartData = data.products
            this.lineChartData = data.customers

            this.rows = res.data.data.rows
          })
          .catch((err) => {
            this.$parent.$emit('alert', 'danger', err.response.data.data.error)
          })

      },
    }

  }
</script>
